import React from 'react';

const HintArrow = ({ styles }) => {
  return <div className={styles}></div>;
};

export default HintArrow;
